import { createActions, using } from "redux-box";

export default createActions({
  requestAnalyticsStory: using(),
  requestProjectsList:using(),
  requestMagicOtp: using(),
  updateMagicOtp: using("data"),
});
